import { render, staticRenderFns } from "./post-details.vue?vue&type=template&id=0acc2270&"
import script from "./post-details.ts?vue&type=script&lang=ts&"
export * from "./post-details.ts?vue&type=script&lang=ts&"
import style0 from "./post-details.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports